/* eslint-disable @typescript-eslint/naming-convention */
import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { PAGE_TYPES, SiteMetaData } from "./constants";
import config from "../config";
import { getUrlPath } from "./helpers";
import source from "./source";

const useBranchIoLinkGeneration = ({
	id,
	campaign = "Apna Main Website",
	custom_utm_medium = PAGE_TYPES.long,
	custom_utm_campaign = undefined,
	description = SiteMetaData.description,
	desktopUrl = undefined,
	notificationType = "REFERRAL",
	feature = "apna-website",
	channel = "Apna Main Website",
	custom_utm_source = "Apna Main Website",
	branchCampaign = null,
	branchStage = "Website",
	branchProps = {},
	pageType,
	section,
}) => {
	const router = useRouter();
	const utm_campaign = router?.query?.utm_campaign || custom_utm_campaign || source();
	const utm_source = router?.query?.utm_source || custom_utm_source;
	const utm_medium = router?.query?.utm_medium || custom_utm_medium || source();
	const primaryUrl = `https://play.google.com/store/apps/details?id=com.apnatime&ref=w&utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`;
	const [url, setUrl] = useState(primaryUrl);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(false);
	const branch = typeof window !== "undefined" && window.branch;

	useEffect(() => {
		if (typeof window !== "undefined") {
			if (window && !window.branch) {
				import("../libs/BranchIO").then((BranchIo) => {
					BranchIo.default.initialize(config.branchIO);
				});
			}
			setLoading(true);
			window.branch &&
				window.branch.link(
					{
						"~channel": channel, // source
						"~feature": feature, // medium utm
						stage: branchStage,
						"~campaign": branchCampaign || campaign, // campaign - change for each section click
						data: {
							$canonical_identifier: "apna/share_post",
							referrer_id: id,
							notification_type: notificationType,
							$desktop_url: desktopUrl || primaryUrl,
							$og_title: "Check Out Apna For Finding Jobs Around You",
							$og_description: description,
							$og_image_url: SiteMetaData.imageFullPath,
							$publicly_indexable: "true",
							source: "Website",
							$android_url: primaryUrl,
							$ios_url: desktopUrl || primaryUrl,
							$ipad_url: desktopUrl || primaryUrl,
							$pageType: pageType,
							$pageUrl: getUrlPath(),
							$section: section,
							"~channel": channel, // source
							"~feature": feature, // medium utm
							stage: branchStage,
							"~campaign": branchCampaign || campaign,
							...branchProps,
						},
					},
					(err, link) => {
						setUrl(link);
						setLoading(false);
						if (err) setError(true);
					}
				);
		}
	}, [campaign, branch]);
	return [url, loading, error];
};

export default useBranchIoLinkGeneration;
